import type { Metadata, Viewport } from "next";

export const metadata: Metadata = {
  title: "Nengo - Japanese History Quiz",
  description: "Learn Japanese historical dates with flashcards",
  manifest: "/manifest.json",
  appleWebApp: {
    capable: true,
    statusBarStyle: "black-translucent",
    title: "Nengo",
  },
};

export const viewport: Viewport = {
  width: "device-width",
  initialScale: 1,
  maximumScale: 1,
  userScalable: false,
  themeColor: "#C41001",
};

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="ja">
      <head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=BIZ+UDGothic&family=Kaisei+Tokumin&display=swap" rel="stylesheet" />
        <link rel="apple-touch-icon" href="/client/images/icon-192.png" />
        <style dangerouslySetInnerHTML={{ __html: `
          @font-face {
            font-family: 'Optima Nova';
            src: url('/client/optima_nova_black.ttf') format('truetype');
            font-weight: 900;
            font-style: normal;
            font-display: swap;
          }
          * { margin: 0; padding: 0; box-sizing: border-box; }
          html, body, #root { width: 100%; height: 100%; overflow: hidden; }
          body {
            font-family: 'Optima Nova', 'Kaisei Tokumin', 'BIZ UDGothic', 'Segoe UI',
                         -apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif;
            background: #C41001;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
          #root:empty::after {
            content: 'Loading...';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-size: 18px;
          }
        ` }} />
      </head>
      <body>{children}</body>
    </html>
  );
}
